import styled from "styled-components"

const Title = styled.h2`
  &::before {
    content: "// ";
    color: ${(props) => props.theme.a_color_gradients.a_dark};
    background-color: transparent !important;
  }
}
`

const Description = styled.p`
  color: ${(props) => props.theme.c_color_gradients.c_dark};
`

export { Title, Description }
